import React, { useEffect, useState } from 'react';
import { useFormikContext } from 'formik';
import FolioCheckbox from '@/components/FolioCheckbox';
import { ConfirmDialog } from '@/components/dialogs/ConfirmDialog';
import { useListRelationshipContactsQuery } from '@/features/relationshipContacts/relationshipContactsApi';

const PrimaryContactCheckbox = ({ disabled, relationshipContactId }) => {
	const { values, setFieldValue } = useFormikContext();
	const [confirmOpen, setConfirmOpen] = useState(false);

	const { relationshipCompanyId, isPrimary } = values;

	const { currentData: relationshipContacts, isFetching } = useListRelationshipContactsQuery(
		{ relationshipCompanyId, includeArchived: true },
		{ skip: !relationshipCompanyId },
	);

	const currentPrimaryContact = relationshipContacts?.find(
		(contact) => contact.isPrimary && contact.id !== relationshipContactId,
	);

	const isPrimaryRequired =
		Boolean(relationshipCompanyId) &&
		!isFetching &&
		Boolean(relationshipContacts) &&
		!currentPrimaryContact;

	useEffect(() => {
		if (isPrimaryRequired && !isPrimary) {
			setFieldValue('isPrimary', true);
		}
	}, [isPrimaryRequired, isPrimary, setFieldValue]);

	const handleChange = ({ target: { checked } }) => {
		if (!checked && isPrimaryRequired) {
			return;
		}

		if (checked && currentPrimaryContact) {
			setConfirmOpen(true);
			return;
		}

		setFieldValue('isPrimary', checked);
	};

	return (
		<>
			<FolioCheckbox
				checked={isPrimary}
				label='Primary contact'
				disabled={disabled || isPrimaryRequired}
				onChange={handleChange}
			/>

			<ConfirmDialog
				openDialog={confirmOpen}
				handleClose={() => setConfirmOpen(false)}
				handleConfirm={() => {
					setFieldValue('isPrimary', true);
					setConfirmOpen(false);
				}}
				title='Set as primary contact'
				content={`This will remove ${currentPrimaryContact?.fullName} as the primary contact for this company.`}
				confirmText='Set as primary'
				canBeUndone
			/>
		</>
	);
};

export default PrimaryContactCheckbox;
